<script>
  // Patterns
  import Feature from '@/Patterns/Feature.svelte';
  import Envision from '@/Patterns/Envision.svelte';
  import Pitch from '@/Patterns/Pitch.svelte';
  import Relation from '@/Patterns/Relation.svelte';
  import Utility from '@/Patterns/Utility.svelte';
  import Scope from '@/Patterns/Scope.svelte';
  import Presence from '@/Patterns/Presence.svelte';
  import Connect from '@/Patterns/Connect.svelte';

  export let matrix;
  export let eidos;

  $: crown = matrix.crown;
  $: navs = matrix.navs;
  $: feature = eidos.feature;
  $: envision = eidos.envision;
  $: pitch = eidos.pitch;
  $: relation = eidos.relation;
  $: utility = eidos.utility;
  $: scope = eidos.scope;
  $: presence = eidos.presence;
  $: connect = matrix.connect;

</script>

<style></style>

<main>
  <Feature {crown} {navs} {feature}/>
  <Envision {envision} />
  <Pitch {pitch} />
  <Relation {relation} />
  <Utility {utility} />
  <Scope {scope} />
  <Presence {presence} />
  <Connect {connect} />
</main>